export const GENERAL = {
    "oauthClientId": "_COuq8L3w213xo3tmk-EaeE9IJJ1IsYuNr8eXc4AJEo",
    "oauthClientSecret": "U4EdL9WfRWds5aG8vujNQDN0Qf1G6M3X9j9GjW7vR74",
    "monsidoPath": "https://login.qa.monsido.com/",
    "sudoRedirectUri": "",
    "version": "2.2.7"
}